import React from 'react';
import PropTypes, { any } from 'prop-types';
import { Link } from 'react-router-dom';

import BackgroundImage from '../../../BackgroundImage';

import styles from '../collegeCoachViews.scss';
import StatsigLink from '../../../Links/StatsigLink';
import { useStatsig } from '../../../hooks/useStatsig';

const CoachViewProfileCard = ({ view }) => {
    const { clubName, clubId, viewingPlayerId, coachFirstName, coachLastName, clubProfileImages, displayViewDate } = view || {};
    const { featureGates } = useStatsig();
    return (
        <div className={styles.cardContainer}>
            <div className={styles.collegeContent}>
                <div>
                    <BackgroundImage
                        baseUrl={'/v1/club/'}
                        defaultImage={'/img/v2/icons/icon-avatar-college.svg'}
                        images={clubProfileImages}
                        imageType={'profile'}
                        parentStylesClass={styles.collegeLogo}
                    />
                </div>
                <div className={styles.collegeInfo}>
                    <Link className={styles.link} to={`/profiles/${viewingPlayerId}`}>{`${coachFirstName} ${coachLastName}`}</Link>
                    <StatsigLink
                        className={styles.collegeLink}
                        gate={featureGates.CLUB_LINKS_REDIRECT}
                        enabledTo={`/college/${clubId}`}
                        disabledTo={`/clubs/${clubId}`}
                    >
                        {clubName}
                    </StatsigLink>
                </div>
            </div>
            <p className={styles.lastViewedText}>{displayViewDate}</p>
        </div>
    );
};

CoachViewProfileCard.propTypes = {
    view: PropTypes.shape({
        clubName: PropTypes.string,
        clubId: PropTypes.number,
        viewingPlayerId: PropTypes.number,
        coachFirstName: PropTypes.string,
        coachLastName: PropTypes.string,
        clubProfileImages: PropTypes.objectOf(any),
        displayViewDate: PropTypes.string,
    }).isRequired,
};

export default CoachViewProfileCard;
